<template>
	<section :class="show && 'show'" class="lib-sidebar" v-click-outside="closeSidebar">
		<div class="bottom-overlay"></div>
		<a class="x-button" href="javascript:void(0)" @click.prevent="closeSidebar">
			<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="2.12109" width="27" height="3" transform="rotate(45 2.12109 0)" fill="white" />
				<rect x="21.2148" y="2.12109" width="27" height="3" transform="rotate(135 21.2148 2.12109)" fill="white" />
			</svg>
		</a>
		<nav>
			<ul>
				<li><a href="javascript:void(0)" @click.prevent="()=>{scrollTo('our-products')}">Our Products</a> <span></span></li>
				<li><a href="javascript:void(0)" @click.prevent="()=>{scrollTo('lighting-jobs')}">Lighting Jobs</a> <span></span></li>
				<li><a href="javascript:void(0)" @click.prevent="()=>{scrollTo('testimonials')}">Testimonials </a><span></span></li>
				<li><a href="javascript:void(0)" @click.prevent="()=>{scrollTo('contact-us')}">Contact Us </a><span></span></li>
			</ul>
		</nav>
		<div class="contact-information">
			<h3 class="lib-text2 text-white">
				Contact&nbsp;
				<span class="lib-color-orange">Information</span>
			</h3>
			<ul>
				<li>
					<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_439_304)">
							<path
								d="M3.35713 6.38727C4.30099 8.24221 5.82165 9.75632 7.6766 10.7067L9.11861 9.26473C9.29558 9.08775 9.55777 9.02876 9.78718 9.10742C10.5213 9.34994 11.3144 9.48103 12.1272 9.48103C12.4877 9.48103 12.7826 9.77599 12.7826 10.1365V12.424C12.7826 12.7845 12.4877 13.0795 12.1272 13.0795C5.97241 13.0795 0.984375 8.09146 0.984375 1.93671C0.984375 1.57621 1.27933 1.28125 1.63983 1.28125H3.93394C4.29444 1.28125 4.58939 1.57621 4.58939 1.93671C4.58939 2.75603 4.72049 3.54258 4.963 4.27669C5.03511 4.5061 4.98267 4.76173 4.79914 4.94526L3.35713 6.38727Z"
								fill="#F98F20"
							/>
						</g>
						<defs>
							<clipPath id="clip0_439_304">
								<rect width="13.7646" height="13.7646" fill="white" transform="translate(0 0.292969)" />
							</clipPath>
						</defs>
					</svg>

					<ul class="lib-email-obfuscation">
						<a href="tel:1-718-376-6608">
							<li>1</li>
							<li class="hidden">this is hidden</li>
							<li>-718-3</li>
							<li>76-66</li>
							<li>08</li>
						</a>

						<li class="hidden">this is hidden</li>
						<li>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</li>
						<li class="hidden">this is hidden</li>
						<a href="tel:718-376-6622">
							<li>718-3</li>
							<li>76-66</li>
							<li>22</li>
							<li class="hidden">this is hidden</li>
						</a>
					</ul>
				</li>

				<a href="https://wa.me/17183766622">
					<li>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36" fill="none">
							<mask id="mask0_971_967" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="36">
								<rect width="36" height="36" fill="url(#pattern02227)" />
							</mask>
							<g mask="url(#mask0_971_967)">
								<rect x="-8.625" y="-11.25" width="55.125" height="59.25" fill="#F98F20" />
							</g>
							<defs>
								<pattern id="pattern02227" patternContentUnits="objectBoundingBox" width="1" height="1">
									<use xlink:href="#image0_971_967" transform="scale(0.0104167)" />
								</pattern>
								<image
									id="image0_971_967"
									width="96"
									height="96"
									xlink:href="data:image/png;base64,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"
								/>
							</defs>
						</svg>

						<ul class="lib-email-obfuscation">
							<li class="hidden">this is hidden</li>
							<li>718-3</li>
							<li>76-66</li>
							<li>22</li>
							<li class="hidden">this is hidden</li>
						</ul>
					</li>
				</a>

				<a href="mailto:accounting@elmlighting.com">
					<li>
						<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_302_8)">
								<path
									d="M16.5612 3.63281H3.31235C2.4015 3.63281 1.66453 4.37806 1.66453 5.28891L1.65625 15.2255C1.65625 16.1364 2.4015 16.8816 3.31235 16.8816H16.5612C17.472 16.8816 18.2173 16.1364 18.2173 15.2255V5.28891C18.2173 4.37806 17.472 3.63281 16.5612 3.63281ZM16.5612 6.94502L9.93676 11.0853L3.31235 6.94502V5.28891L9.93676 9.42917L16.5612 5.28891V6.94502Z"
									fill="#F98F20"
								/>
							</g>
							<defs>
								<clipPath id="clip0_302_8">
									<rect width="19.8732" height="19.8732" fill="white" transform="translate(0 0.324219)" />
								</clipPath>
							</defs>
						</svg>
						<ul class="lib-email-obfuscation">
							<li>accounting@</li>
							<li class="hidden">this is hidden</li>
							<li>elmligh</li>
							<li>ting</li>
							<li>.com</li>
							<li class="hidden">this is hidden</li>
						</ul>
					</li>
				</a>
			</ul>
		</div>
	</section>
</template>
<script>
import Text2 from '@/components/Text2';

export default {
	props: ['show'],
	components: {Text2},
	methods: {
		closeSidebar() {
			this.$emit('close');
		},
		scrollTo(id) {
			this.closeSidebar();
			const element = document.getElementById(id);
			if (element) {
				history.replaceState(null, null, '');
				window.scroll({top: element.offsetTop, behavior: 'smooth'});
			} else {
				location.href = `/#${id}`;
			}
		},
	},
};
</script>
<style scoped lang="scss">
section {
	position: fixed;
	width: 230px;
	transition: all 0.25s ease-in-out;
	height: calc(100% + 0px);
	overflow: auto;
	background: #0f0d3f;
	top: 0;
	right: -230px;
	z-index: 999999999;
	.bottom-overlay {
		height: 100%;
		background: #0f0d3f;
		pointer-events: none;
		width: 100%;
		position: absolute;
	}
	.contact-information {
		bottom: 0;
		position: absolute;
		padding-bottom: 40px;
		left: 0;
		padding-left: 25px;
		padding-right: 25px;
		h3 {
			font-size: 11px !important;
			line-height: 164% !important;
			font-weight: 700;
		}

		ul {
			padding-top: 12.7px;
			display: grid;
			row-gap: 12px;
			li {
				font-size: 9px !important;
				line-height: 164.5% !important;
				color: white;
				display: flex;
				word-break: break-all;
				white-space: nowrap;
				svg {
					margin-right: 8.69px;
					height: 14px;
					width: 17px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
	}
	nav {
		ul {
			display: flex;
			flex-direction: column;
			padding-top: 60px;

			li {
				position: relative;
				display: flex;
				flex-direction: column;
				span {
					height: 3px;
					background: transparent;
					display: block;
					width: 0;
					transition: width 0.1s ease-out;
				}
				a {
					font-weight: 500;
					font-size: 12px;
					line-height: 18px;
					color: white;
					height: 38px;
					width: 230px;
					padding-left: 30px;
					display: flex;
					font-weight: 500;
					align-items: center;
				}

				a:hover,
				a:active,
				a:focus {
					color: #f47120;
				}
				a:active + span {
					width: 100%;
					background: linear-gradient(40.17deg, #eb1b24 -26.95%, #ee3423 -11.81%, #f15622 12.49%, #f47120 37.33%, #f68420 62.57%, #f88f1f 88.49%, #f8931f 116.08%);
				}
			}
		}
	}
	.x-button {
		position: absolute;
		right: 23px;
		top: 16px;
		padding: 10px;
		  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            -webkit-tap-highlight-color: transparent;
	}
}

@media (orientation: portrait) and (min-width: 640px) and (hover: none) {
	section {
		width: 450px !important;
		right: -450px;
		.contact-information {
			padding-left: 60px;
			h3 {
				font-size: 22px !important;
			}
			ul {
				padding-top: 15px;
				row-gap: 15px;
				li {
					font-size: 16px !important;
					line-height: 164.5% !important;
					color: white;
					alig-content: center;
					svg {
						height: 30px;
						width: 40px;
					}
				}
			}
		}

		nav {
			ul {
				padding-top: 110px;
				li {
					font-weight: 700;
					font-size: 27px;
					line-height: 18px;
					span {
						height: 3px;
					}
					a {
						color: white;
						height: 60px;
						width: 450px;
						padding-left: 60px;
						display: flex;
						align-items: center;
					}
				}
			}
		}

		.x-button {
			right: 30px;
			top: 30px;
			svg {
				width: 40px;
				height: 40px;
			}
		}
	}
}

@media (orientation: portrait) and (min-width: 640px) and (hover: none) {
	section {
		nav {
			ul {
				li {
					a {
						font-size: 20px;
					}
				}
			}
		}
	}
}

@media (orientation: portrait) and (min-width: 780px) and (hover: none) {
	section {
		nav {
			ul {
				li {
					a {
						font-size: 22px;
					}
				}
			}
		}
	}
}

@media screen and (orientation: landscape) and (max-height: 600px) {
	section {
		nav {
			display: flex;
			align-items: center;
			height: 100%;
			ul {
				padding: 0;
			}
		}
		.contact-information {
			display: none;
		}
	}
}

section.show {
	right: 0;
}

@media (min-width: 1280px) {
	section {
		display: none;
	}
}
</style>
